import * as NumberUtils from '@/utils/NumberUtils'
import * as EQSize from '../parameters/EQSize'
import { DataPushCompareUtils } from './DataPushCompareUtils'
import { cache } from '@/utils/cacheManager'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { CargoDocUtil } from './CargoDocUtil'
import StrUtils from '@/utils/StrUtils'
import { Container } from '@/class/model/booking/Container'
import { ContainerUsage } from '@/class/model/booking/ContainerUsage'
import { EDIContainer } from '@/class/model/booking/EDIContainer'
import uidUtil from '@/utils/uidUtil'
import i18n from '@/lang'
import { getUuid } from '@/utils'
import { Trucking } from '@/class/model/booking/Trucking'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'

export class ContainerUtil {
  /**
   * 主票自动装箱
   */
  static autoAdjustMasterContainer(job) {
    // 获取新增的container,条件是：没有修改过的SeaEQ和不存在container里面
    const seaEQs = this.getCreateContainerBySeaEQ(job)
    this.createMasterContainer(seaEQs, job)
    // 同步变更的箱种箱型，条件是：装箱信息和箱种箱型数量一致
    this.syncContainerSeaEQ(job)
    // 删除多余的装箱信息
    this.removeMasterContainer(job)
  }

  /**
     * 创建主票装箱信息
     */
  static createMasterContainer(seaEQs, job) {
    for (const item of seaEQs) {
      const quantity = item['quantity']
      const seaEQ = item['seaEQ']
      for (let i = 0; i < quantity; i++) {
        const container = new Container().fillDefaultValue().getData()

        container.isDirty = true
        container.jobUuid = job.uuid
        if (!job.containers) {
          job.containers = []
        }
        job.containers.push(container)

        container.sealNo = ''
        container.containerNo = ''
        container.eqSize = seaEQ.eqSize
        container.eqType = seaEQ.eqType
        container.containerWeight = 0
        container.seaEqs = seaEQ
      }
    }
  }

  /**
     * 刷新装箱信息箱型箱量
     */
  static syncContainerSeaEQ(job) {
    for (const sea of job.seaEQ) {
      for (const container of job.containers) {
        if (container.seaEqs !== null && container.seaEqs.joinContainerId === sea.joinContainerId && (container.eqSize !== sea.eqSize || container.eqType !== sea.eqType)) {
          container.eqSize = sea.eqSize
          container.eqType = sea.eqType
          container.isDirty = true
        }
      }
    }
  }

  /**
     * 删除多余的装箱信息
     */
  static removeMasterContainer(job) {
    const containers = []
    for (const c of job.containers) {
      c.delete = false
      if (!this.isMatchSeqInfo(c, job) && StrUtils.isEmpty(c.containerNo) && StrUtils.isEmpty(c.sealNo)) {
        containers.push(c)
      }
    }
    for (const s of job.seaEQ) {
      const diffs = this.getDiffSeqEqContainer(s, job)
      const needDeleCount = diffs.length - s.eqQuantity
      if (needDeleCount > 0) {
        const allowDelete = this.getAllowDeleteContainerByMaster(diffs)
        if (allowDelete.length > 0) {
          for (let i = 0; i < needDeleCount; i++) {
            if (i <= allowDelete.length) {
              containers.push(allowDelete[i])
            }
          }
        }
      }
    }
    if (containers.length > 0) {
      for (const c3 of containers) {
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (!StrUtils.isEmpty(c3.uuid)) {
          if (!job.delContainerUuids) {
            job.delContainerUuids = []
          }
          job.delContainerUuids.push(c3.uuid)
        }
        c3.jobUuid = ''
        c3.delete = true
      }
    }
    // job.containers.refresh(); 刷新 job 下的containers
    // 根据  jobUuid ，containerUuid 清除 对象上的 [] ,新增状态jobUuid =null
    const tempContainers = []
    for (const container of job.containers) {
      if (!container.delete) {
        tempContainers.push(container)
      }
    }

    job.containers.splice(0, job.containers.length, ...tempContainers)
  }

  /**
     * 删除没有装过小票的箱子
     */
  static getAllowDeleteContainerByMaster(containers) {
    const result = []
    for (const c of containers) {
      if ((c.containerUsage === null || c.containerUsage.length === 0) && StrUtils.isEmpty(c.containerNo) && StrUtils.isEmpty(c.sealNo)) {
        result.push(c)
      }
    }
    return result
  }

  /**
   *  获取新增的container
   *  1.没有修改过箱种箱型
   *  2.完全新增了一个箱种箱型
   */
  static getCreateContainerBySeaEQ(job) {
    const seaEQs = []
    for (const sea of job.seaEQ) {
      const checkCount = this.getJoinContainerCount(sea, job)
      const diff = sea.eqQuantity - checkCount
      // checkCount == 0 说明是新增的箱型信息
      if (checkCount === 0) {
        seaEQs.push({ 'quantity': sea.eqQuantity, 'seaEQ': sea })
      } else {
        if (diff > 0) {
          seaEQs.push({ 'quantity': diff, 'seaEQ': sea })
        }
      }
    }
    return seaEQs
  }

  static getJoinContainerCount(sea, job) {
    let count = 0
    for (const container of job.containers) {
      if (container.seaEqs !== null && container.seaEqs.joinContainerId === sea.joinContainerId) {
        count++
      }
    }
    return count
  }

  //   /**
  //    * 按seaEq生成containers
  //    * 删除不需要的container信息
  //    * 增加需要的container信息
  //    */
  //   public static function adjustContainerUsages(obj:Job):void {
  //     refreshContainers(obj);
  //     //先统计各箱型箱种的数量
  //     var seaeqcounts:ArrayCollection=mergeSeaEqCount(obj);
  //     // 删除不需要的container信息
  //     // 增加需要的container信息
  //     var containerCount:int;
  //     for each(var seaeq:SeaEQ in seaeqcounts) {
  //       //调整container信息
  //       adjustContainerUsage(obj,seaeq.EQsize,seaeq.EQtype,seaeq.EQquantity)
  //     }
  //     if(removeNonExistedContainers(obj)) {
  //     }
  //     refreshContainers(obj);
  //     refreshContainersJobs(obj);
  //   }
  //
  //   /**
  //    *  @private
  //    *	增加 ContainerUsage 和containers 值
  //    */
  //   private static function addContainerUsage(eqsize:String,eqtype:String, input:Job):ContainerUsage {
  //     var u:ContainerUsage = new ContainerUsage();
  //     u.job = input;
  //     var newCont:com.walltech.cargo.model.Container = new com.walltech.cargo.model.Container();
  //     newCont.job = input;
  //     u.container = newCont;
  //     newCont.sealNo = "";
  //     newCont.containerNo = "";
  //     newCont.EQsize = eqsize;
  //     newCont.EQtype = eqtype;
  //     newCont.containerWeight = 0;
  //     input.containers.addItem(newCont);
  //     return u;
  //   }
  //
  //
  //   /** 将指定箱型箱种的container信息调整至正确数量
  //    *  删除不需要的container信息
  //    *  增加需要的container信息
  //    */
  //   public static function adjustContainerUsage(obj:Job,eqsize:String,eqtype:String,count:Number):void
  //   {
  //     var canDeleCount:Number =0
  //     var cantDeleCount:Number =0;
  //     var canDeleContainer:ArrayCollection = new ArrayCollection();
  //     var c:com.walltech.cargo.model.Container;
  //     var i:int;
  //     var u:ContainerUsage;
  //     var container_ref:ArrayCollection;
  //     if(obj is SeaExportJob){
  //     container_ref = SeaExportJob(obj).container_ref;
  //   }
  //     if(obj is SeaImportJob){
  //     container_ref = SeaImportJob(obj).container_ref;
  //   }
  //     if(obj is RailwayExportJob){
  //     container_ref = RailwayExportJob(obj).container_ref;
  //   }
  //     if (!obj.isMasterFlag)
  //     {
  //       for each (c in container_ref)
  //       {
  //         if (c.EQsize ==eqsize&&c.EQtype==eqtype)
  //         {
  //           if (isContainerInfoSet(c))
  //           {
  //             cantDeleCount++;
  //           }
  //           else
  //           {
  //             canDeleCount++;
  //             if (!canDeleContainer.contains(c))
  //             {
  //               canDeleContainer.addItem(c);
  //             }
  //           }
  //         }
  //       }
  //     }
  //     else
  //     {
  //       for each (c in container_ref)
  //       {
  //         if (c.EQsize ==eqsize&&c.EQtype==eqtype)
  //         {
  //           if (isContainerBound(obj,c))
  //           {
  //             cantDeleCount++;
  //           }
  //           else
  //           {
  //             canDeleCount++;
  //             if (!canDeleContainer.contains(c))
  //             {
  //               canDeleContainer.addItem(c);
  //             }
  //           }
  //         }
  //       }
  //     }
  //     //调整
  //     if (canDeleCount+cantDeleCount>count)
  //     {
  //       //删除
  //       var needDeleCount:Number = canDeleCount+cantDeleCount-count;
  //       if (needDeleCount>canDeleCount)
  //       {
  //         //最多删除能删除的container信息
  //         needDeleCount = canDeleCount;
  //       }
  //       i=0;
  //       for each (c in canDeleContainer)
  //       {
  //         if (needDeleCount>i)
  //         {
  //           removeContainer(obj,c);
  //           i++;
  //         }
  //       }
  //     }
  //     else if (canDeleCount+cantDeleCount<count)
  //     {
  //       //增加
  //       var needAddCount:Number = count-canDeleCount-cantDeleCount
  //       for (i=1;i<=needAddCount;i++)
  //       {
  //         getNewContainerUsage(eqsize,eqtype, obj);
  //       }
  //     }
  //   }

  /**
   *获取 箱量描述
   */
  static getSeaeqNumberStr(obj) {
    let amount = 0
    if (obj.seaEQ instanceof Array) {
      for (const s of obj.seaEQ) {
        amount += s.eqQuantity
      }
    }
    return StrUtils.jsdx(amount, 'CONTAINER(S)')
  }

  /**
   *比较订舱单和装箱的件重体 obj
   *返回null：表示全部相符
   */
  static getCompareMessage(obj, quantity, weight, cubage) {
    let strQuantity = 0
    let strWeight = 0
    let strCubage = 0
    let strAlert = ''
    let msg = ''

    if (quantity === 0 && weight === 0 && cubage === 0) { return null }
    // CARGO-8232, 装箱信息件毛体和实际件毛体信息一致，无法保存
    if (obj.lob === 'SE' || obj.lob === 'RE' || obj.lob === 'RI' || obj.lob === 'IE') {
      strQuantity = isNaN(obj.quantityActual) ? 0 : Number(obj.quantityActual)
      strWeight = isNaN(obj.weightActual) ? 0 : Number(obj.weightActual)
      strCubage = isNaN(obj.cubageActual) ? 0 : Number(obj.cubageActual)

      strAlert = '实际'
      // fix bug 1691 by marco.
      if (strQuantity === 0 && strWeight === 0 && strCubage === 0) {
        strQuantity = isNaN(obj.quantityContract) ? 0 : Number(obj.quantityContract)
        strWeight = isNaN(obj.weightContract) ? 0 : Number(obj.weightContract)
        strCubage = isNaN(obj.cubageContract) ? 0 : Number(obj.cubageContract)
        strAlert = '委托'
      }
    } else if (obj.lob === 'SI') {
      strQuantity = isNaN(obj.quantityActual) ? 0 : Number(obj.quantityActual)
      strWeight = isNaN(obj.weightActual) ? 0 : Number(obj.weightActual)
      strCubage = isNaN(obj.cubageActual) ? 0 : Number(obj.cubageActual)
      strAlert = '实际'
    }

    if (quantity === strQuantity && weight === strWeight && cubage === strCubage) { return null }

    if (!StrUtils.NumberIsSame(quantity, strQuantity)) {
      if (quantity > strQuantity) {
        msg += '总件数' + quantity + ' 大于' + strAlert + '件数' + strQuantity + '\n'
      } else {
        msg += '总件数' + quantity + ' 小于' + strAlert + '件数' + strQuantity + '\n'
      }
    }
    if (obj.lob === 'SE') {
      if (weight.toFixed(3) > strWeight.toFixed(3)) {
        msg += '总重量' + weight + ' 大于' + strAlert + '重量' + strWeight + '\n'
      }
      if (weight.toFixed(3) < strWeight.toFixed(3)) {
        msg += '总重量' + weight + ' 小于' + strAlert + '重量' + strWeight + '\n'
      }
      if (cubage.toFixed(3) > strCubage.toFixed(3)) {
        msg += '总体积' + cubage + ' 大于' + strAlert + '体积' + strCubage + '\n'
      }
      if (cubage.toFixed(3) < strCubage.toFixed(3)) {
        msg += '总体积' + cubage + ' 小于' + strAlert + '体积' + strCubage + '\n'
      }
    } else {
      if (!StrUtils.NumberIsSame(weight, strWeight, 2)) {
        if (weight > strWeight) {
          msg += '总重量' + weight + ' 大于' + strAlert + '重量' + strWeight + '\n'
        } else {
          msg += '总重量' + weight + ' 小于' + strAlert + '重量' + strWeight + '\n'
        }
      }
      if (!StrUtils.NumberIsSame(cubage, strCubage, 3)) {
        if (cubage > strCubage) {
          msg += '总体积' + cubage + ' 大于' + strAlert + '体积' + strCubage + '\n'
        } else {
          msg += '总体积' + cubage + ' 小于' + strAlert + '体积' + strCubage + '\n'
        }
      }
    }
    if (msg === '') {
      return null
    }
    return msg
  }

  //   public static function removeContainer(obj:Job,container:com.walltech.cargo.model.Container):void
  //   {
  //     var needRemoveUsages:ArrayCollection = new ArrayCollection();
  //     var u:ContainerUsage;
  //     for each(u in obj.containerUsages)
  //     {
  //       if (u.container == container)
  //       {
  //         if (!needRemoveUsages.contains(u))
  //         {
  //           needRemoveUsages.addItem(u);
  //         }
  //       }
  //     }
  //     for each (u in needRemoveUsages)
  //     {
  //       if(container.containerUsage){
  //         if (container.containerUsage.contains(u))
  //         {
  //           container.containerUsage.removeItemAt(container.containerUsage.getItemIndex(u));
  //         }
  //       }
  //       u.container = null;
  //       if (obj.containerUsages.contains(u))
  //       {
  //         obj.containerUsages.removeItemAt(obj.containerUsages.getItemIndex(u));
  //       }
  //     }
  //     //彻底删除该container
  //     var j:Job = container.job;
  //     container.job = null;
  //     if (j.containers && j.containers.contains(container)){
  //       j.containers.removeItemAt(j.containers.getItemIndex(container));
  //     }
  //   }
  //
  //   /**
  //    * 合并相同箱型箱种的数量
  //    */
  //   public static function mergeSeaEqCount(obj:Job):ArrayCollection
  //   {
  //     var seaeqcounts:ArrayCollection = new ArrayCollection();
  //     for each (var seaeq1:SeaEQ in obj.seaEQ)
  //     {
  //       var found:Boolean = false;
  //       for each (var seaeq2:SeaEQ in seaeqcounts)
  //       {
  //         if (seaeq1.EQsize==seaeq2.EQsize && seaeq1.EQtype==seaeq2.EQtype)
  //         {
  //           found=true;
  //         }
  //       }
  //       if (!found)
  //       {
  //         var count:int = getSeaEQCount(obj,seaeq1.EQsize,seaeq1.EQtype);
  //         if (count!=0)
  //         {
  //           var seaeq:SeaEQ = new SeaEQ();
  //           seaeq.EQsize = seaeq1.EQsize;
  //           seaeq.EQtype = seaeq1.EQtype;
  //           seaeq.EQquantity = count;
  //           if (!seaeqcounts.contains(seaeq))
  //           {
  //             seaeqcounts.addItem(seaeq);
  //           }
  //         }
  //       }
  //     }
  //     return seaeqcounts;
  //   }
  //   /** 获取主票未拼箱小票
  //    */
  //   public static function refreshContainersJobs(input:Job):void
  //   {
  //
  //     if (input.isMasterFlag)
  //     {
  //       if(input is SeaExportJob){
  //       SeaExportJob(input).containerJobs_ref = new ArrayCollection();
  //     }if(input is SeaImportJob){
  //       SeaImportJob(input).containerJobs_ref = new ArrayCollection();
  //     }
  //       if(input is RailwayExportJob){
  //       RailwayExportJob(input).containerJobs_ref = new ArrayCollection();
  //     }
  //       if (input.lclSlaves!=null)
  //       {
  //         for each(var job:Job in input.lclSlaves)
  //         {
  //           if (job.containerUsages==null||job.containerUsages.length ==0){
  //             if(input is SeaExportJob){
  //               SeaExportJob(input).containerJobs_ref.addItem(job);
  //             }if(input is SeaImportJob){
  //               SeaImportJob(input).containerJobs_ref.addItem(job);
  //             }
  //             if(input is RailwayExportJob){
  //               RailwayExportJob(input).containerJobs_ref.addItem(job);
  //             }
  //           }else{
  //             //该job已有拼箱数据的情况
  //             var quantity:int = job.quantityActual;
  //             for each (var usage:ContainerUsage in job.containerUsages)
  //             {
  //               quantity = quantity - usage.quantity;
  //             }
  //             if(quantity > 0)
  //             {
  //               if(input is SeaExportJob){
  //               SeaExportJob(input).containerJobs_ref.addItem(job);
  //             }if(input is SeaImportJob){
  //               SeaImportJob(input).containerJobs_ref.addItem(job);
  //             }
  //               if(input is RailwayExportJob){
  //               RailwayExportJob(input).containerJobs_ref.addItem(job);
  //             }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  //
  //   /**
  //    * 增加箱子信息
  //    */
  //   private static function getNewContainerUsage(eqsize:String,eqtype:String,input:Job):void
  //   {
  //     var container:Container = getNewContainer(eqsize,eqtype,input);
  //     if (!input.isMasterFlag)
  //     {
  //       var u:ContainerUsage = getNewContainerUsageTo(input);
  //       u.container = container;
  //     }
  //   }
  //
  //   /**
  //    * 装箱信息
  //    */
  //   private static function getNewContainerUsageTo(input:Job):ContainerUsage
  //   {
  //     var u:ContainerUsage = new ContainerUsage();
  //     u.job = input;
  //     u.quantity = 0;
  //     u.weight = 0;
  //     u.cubage = 0;
  //     return u;
  //   }
  //
  //   /**
  //    * 装箱信息
  //    */
  //   private static function getNewContainer(eqsize:String,eqtype:String,input:Job):Container
  //   {
  //     var newCont:com.walltech.cargo.model.Container = new com.walltech.cargo.model.Container();
  //     newCont.job = input;
  //     newCont.sealNo = "";
  //     newCont.containerWeight = 0;
  //     newCont.containerNo = "";
  //     newCont.EQsize = eqsize;
  //     newCont.EQtype = eqtype;
  //     if(input.containers == null){
  //       input.containers = new ArrayCollection();
  //     }
  //     return newCont;
  //   }
  //
  //   /** 删除箱量时，删除多余箱封信息,containerUsager或箱号，封号信息已输入不能删除
  //    *  isCheck为false时：返回true:已输入箱封信息的箱型箱种信息被强制删除
  //    *  isCheck为true时：返回true:已输入箱封信息的箱型箱种没有被删，需要提示
  //    */
  //   public static function removeContainers(eq:SeaEQ, input:Job,isCheck:Boolean=false):Boolean {
  //     var needWarnUser:Boolean = false;
  //     var removed:Boolean = false;
  //     var index:int = 0;
  //     var u:ContainerUsage;
  //     refreshContainers(input);
  //     var containerArray:ArrayCollection = returnContainerRefFun(input);
  //     for each(var container:com.walltech.cargo.model.Container in containerArray) {
  //       if(container.EQsize == eq.EQsize && container.EQtype == eq.EQtype) {
  //         if(!isContainerInfoSet(container)) {
  //           //删除箱封信息
  //           //从containerUsage中删除container
  //           for each(u in input.containerUsages)
  //           {
  //             if (u.container.EQsize==container.EQsize && u.container.EQtype == container.EQtype)
  //             {
  //               index = input.containerUsages.getItemIndex(u);
  //               input.containerUsages.removeItemAt(index);
  //             }
  //           }
  //           refreshContainers(input);
  //           removed = true;
  //           break;
  //         }
  //         else {
  //           if (!isCheck)
  //           {
  //             //删除箱封信息
  //             //从containerUsage中删除container
  //             for each(u in input.containerUsages)
  //             {
  //               if (u.container.EQsize==container.EQsize && u.container.EQtype == container.EQtype)
  //               {
  //                 index = input.containerUsages.getItemIndex(u);
  //                 input.containerUsages.removeItemAt(index);
  //               }
  //             }
  //             refreshContainers(input);
  //           }
  //           needWarnUser = true;
  //         }
  //       }
  //     }
  //     return needWarnUser;
  //   }
  //
  //   /**删除没有对应箱型、箱种的箱封信息
  //    *
  //    */
  //   private static function removeNonExistedContainers(input:Job):Boolean {
  //     var needWarnUser:Boolean = false;
  //     var u:ContainerUsage;
  //     var containerArray:ArrayCollection = returnContainerRefFun(input);
  //     for each(var container:com.walltech.cargo.model.Container in containerArray) {
  //       var found:Boolean = false;
  //       for each(var eq:SeaEQ in input.seaEQ) {
  //         if(eq.EQsize == container.EQsize && eq.EQtype == container.EQtype) {
  //           found = true;
  //           break;
  //         }
  //       }
  //       if(!found) {
  //         if (!input.isMasterFlag)
  //         {
  //           if(isContainerInfoSet(container)) {
  //             needWarnUser = true;
  //           }
  //           else
  //           {
  //             removeContainer(input,container);
  //           }
  //         }
  //         else
  //         {
  //           if(isContainerBound(input,container)) {
  //             needWarnUser = true;
  //           }
  //           else
  //           {
  //             removeContainer(input,container);
  //           }
  //         }
  //       }
  //     }
  //     return needWarnUser;
  //   }
  //

  /**
   * true: 有重复
   * false:无重复
   */
  static checkNoDuplationSeaEQ(job) {
    for (const s of job.seaEQ) {
      if (this.checkSeaEq(job, s)) {
        return true
      }
    }
    return false
  }

  /** 箱型箱种输入验证
     * 不正确 return true;
     */
  static checkSeaEq(job, seaEq) {
    for (const s of job.seaEQ) {
      if (seaEq !== s && s.eqSize === seaEq.eqSize && s.eqType === seaEq.eqType) {
        return true
      }
    }
    return false
  }

  // CARGO-8266，已经选择了敞车/棚车/平车，不能选择这三种箱种外的箱种
  static checkSeaEqType(job) {
    if (job.lob === 'RE' || job.lob === 'RI') {
      let bExistGP = false
      let bExistRE = false
      for (const s of job.seaEQ) {
        if (s.eqType === '敞车' || s.eqType === '棚车' || s.eqType === '平车') {
          bExistRE = true
        } else {
          bExistGP = true
        }
      }
      if (bExistRE && bExistGP) {
        return true
      }
    }
    return false
  }

  /**
   * 验证箱量是否有值
   * true: 有重复
   * false:无重复
   */
  static checkQuantityFromSeaEQ(job) {
    for (const s of job.seaEQ) {
      if (s.deleted) continue
      if (!s.eqQuantity || Number(s.eqQuantity) <= 0) {
        return true
      }
    }
    return false
  }

  //   /**返回seaeq中该箱型箱种数量
  //    */
  //   public static function getSeaEQCount(job:Job,eqsize:String,eqtype:String):int
  //   {
  //     var count:int=0;
  //     for each(var s:SeaEQ in job.seaEQ)
  //     {
  //       if (s.EQsize==eqsize&&s.EQtype==eqtype)
  //       {
  //         count+=s.EQquantity;
  //       }
  //     }
  //     return count;
  //   }
  //
  //   /**刷新箱子信息,整箱job.containerUsages--u.container
  //    * 拼箱主单需计算各拼箱小票
  //    * 合并后数据放到container_ref
  //    */
  //   public static function refreshContainers(obj:Job):void
  //   {
  //     //合计containers
  //     var u:ContainerUsage;
  //     var c:com.walltech.cargo.model.Container;
  //     var containers:ArrayCollection = new ArrayCollection();
  //     if (obj.containerUsages!=null)
  //     {
  //       for each(u in obj.containerUsages)
  //       {
  //         if (!containers.contains(u.container))
  //         {
  //           containers.addItem(u.container);
  //         }
  //       }
  //       //容错用，获取job下的那些containers
  //       for each (c in obj.containers)
  //       {
  //         if (!containers.contains(c))
  //         {
  //           containers.addItem(c);
  //         }
  //       }
  //     }
  //     //获取子票中对应的箱子
  //     if (obj.isMasterFlag==true && obj.lclSlaves!=null)
  //     {
  //       for each(var job:Job in obj.lclSlaves)
  //       {
  //         if (job.containerUsages==null) continue;
  //         for each(u in job.containerUsages)
  //         {
  //           if (!containers.contains(u.container))
  //           {
  //             containers.addItem(u.container);
  //           }
  //         }
  //       }
  //     }
  //     for each(c in containers)
  //     {
  //       if ((c.containerUsage == null || c.containerUsage.length == 0) && c.job && !c.job.isMasterFlag)
  //       {
  //         var usage:ContainerUsage = getNewContainerUsageTo(c.job);
  //         usage.container = c;
  //       }
  //     }
  //     if(obj is SeaExportJob){
  //     SeaExportJob(obj).container_ref = containers;
  //   }if(obj is SeaImportJob){
  //     SeaImportJob(obj).container_ref = containers;
  //   }
  //     if(obj is RailwayExportJob){
  //     RailwayExportJob(obj).container_ref = containers;
  //   }
  //   }
  //   /**检查箱封信息的箱号或封号是否已输入
  //    * 有输入 return true
  //    */
  //   public static function isContainerInfoSet(container:com.walltech.cargo.model.Container):Boolean {
  //     if(container.containerNo!=null && container.containerNo.length > 0) return true;
  //     if(container.sealNo!=null && container.sealNo.length > 0) return true;
  //     //			if(container.quantity > 0) return true;
  //     //if(container.weight && container.weight.length > 0) return true;
  //     //if(container.cubage && container.cubage.length > 0) return true;
  //     return false;
  //   }
  //   /**返回container_ref中该箱型箱种不能被删除的箱封信息的记录数
  //    * 整箱已输入箱封信息数量
  //    * 拼箱已绑定拼箱小票的箱封信息数量
  //    */
  //   public static function getContainerCount(job:Job,eqsize:String,eqtype:String):int
  //   {
  //     var c:com.walltech.cargo.model.Container;
  //     var count:int=0;
  //     var containerArray:ArrayCollection = returnContainerRefFun(job);
  //     if (!job.isMasterFlag)
  //     {
  //       for each(c in containerArray)
  //       {
  //         if (c.EQsize==eqsize&&c.EQtype==eqtype)
  //         {
  //           if (isContainerInfoSet(c))
  //           {
  //             count++;
  //           }
  //         }
  //       }
  //     }
  //     else
  //     {
  //       for each(c in containerArray)
  //       {
  //         if (c.EQsize==eqsize&&c.EQtype==eqtype)
  //         {
  //
  //           if (isContainerInfoSet(c))
  //           {
  //             count++;
  //           }
  //           else if (isContainerBound(job,c))
  //           {
  //             //拼箱主票需检查是否已有绑定到小票下的usage
  //             count++;
  //           }
  //         }
  //       }
  //     }
  //     return count;
  //   }
  //   /**已绑定拼箱小票container
  //    * 有绑定 return true
  //    * 参数job是拼箱主票
  //    */
  //   public static function isContainerBound(job:Job,container:com.walltech.cargo.model.Container):Boolean {
  //     if(container.containerUsage!=null)
  //     {
  //       for each(var u:ContainerUsage in container.containerUsage)
  //       {
  //         if (u.job!=null&&u.job.isMasterFlag==false &&u.job!=job)
  //         {
  //           return true;
  //         }
  //       }
  //
  //     }
  //     return false;
  //   }
  //
  //   public static function returnContainerRefFun(input:Job):ArrayCollection{
  //     var containerArray:ArrayCollection;
  //     if(input is SeaExportJob){
  //       containerArray = SeaExportJob(input).container_ref;
  //     }if(input is SeaImportJob){
  //       containerArray = SeaImportJob(input).container_ref;
  //     }
  //     if(input is RailwayExportJob){
  //       containerArray = RailwayExportJob(input).container_ref;
  //     }
  //
  //     return containerArray;
  //   }
  //
  /**
   * 自动装箱
   */
  static autoLoadContainerUsage(job) {
    let quantity = job.quantityActual
    let weight = isNaN(job.weightActual) ? 0 : job.weightActual
    let cubage = isNaN(job.cubageActual) ? 0 : job.cubageActual

    // fix bug 1691 by marco.
    if (quantity === 0 && weight === 0 && cubage === 0) {
      quantity = job.quantityContract
      weight = isNaN(job.weightContract) ? 0 : job.weightContract
      cubage = isNaN(job.cubageContract) ? 0 : job.cubageContract
    }

    if (quantity === 0 && weight === 0 && cubage === 0 || job.containerUsages === null) { return }

    let usage
    let tsize = 0
    for (usage of job.containerUsages) {
      const eqsize = EQSize.getEQSizeByCode(usage.container.eqSize)
      if (eqsize) { tsize += parseInt(eqsize.code) }
    }

    let tq = 0
    let tw = 0
    let tc = 0
    const len = job.containerUsages.length
    for (let i = 0; i < len; i++) {
      usage = job.containerUsages[i]
      // CARGO-33106 14492-运采通 铁路业务-装箱信息“自动装箱“，没有装箱逻辑；
      // CARGO-8266，铁路出口业务，自动装箱不要分摊
      // if (job.lob === 'RE' || job.lob === 'RI') {
      //   if (i === 0) {
      //     usage.quantity = quantity
      //     usage.weight = weight
      //     usage.cubage = cubage
      //   }
      // }
      if (i === len - 1) {
        usage.quantity = NumberUtils.roundHalfUp(quantity - tq, 0)
        usage.weight = NumberUtils.roundHalfUp(weight - tw, 3)
        usage.cubage = NumberUtils.roundHalfUp(cubage - tc, 3)
      } else {
        const size = EQSize.getEQSizeByCode(usage.container.eqSize)
        if (size) {
          const rate = parseInt(size.code) / tsize
          tq += usage.quantity = NumberUtils.roundHalfUp(rate * quantity, 0)
          tw += usage.weight = NumberUtils.roundHalfUp(rate * weight, 3)
          tc += usage.cubage = NumberUtils.roundHalfUp(rate * cubage, 3)
        } else {
          usage.quantity = usage.weight = usage.cubage = 0
        }
      }
      // CARGO-21347 海出业务，装箱信息页签，列表上加“包装”显示列
      if (!usage.uuid) {
        usage.packing = job.packing
      }

      if (usage.container) {
        usage.container.cargoName = usage.cargoName = job.cargoEnglishName
        usage.container.mark = usage.mark = job.mark
        usage.container.quantity = usage.quantity
        usage.container.weight = usage.weight
        usage.container.cubage = usage.cubage
      }
      usage.hsCode = job.hsCode
    }
  }

  /**
   * 自动装箱(委托)
   */
  static autoLoadContainerUsageContract(job) {
    let quantity = job.quantityContract
    let weight = isNaN(job.weightContract) ? 0 : job.weightContract
    let cubage = isNaN(job.cubageContract) ? 0 : job.cubageContract

    if (quantity === 0 && weight === 0 && cubage === 0) {
      quantity = job.quantityActual
      weight = isNaN(job.weightActual) ? 0 : job.weightActual
      cubage = isNaN(job.cubageActual) ? 0 : job.cubageActual
    }

    if (quantity === 0 && weight === 0 && cubage === 0 || job.containerUsages === null) { return }

    let usage
    let tsize = 0
    for (usage of job.containerUsages) {
      const eqsize = EQSize.getEQSizeByCode(usage.container.eqSize)
      if (eqsize) { tsize += parseInt(eqsize.code) }
    }

    let tq = 0
    let tw = 0
    let tc = 0
    const len = job.containerUsages.length
    for (let i = 0; i < len; i++) {
      usage = job.containerUsages[i]
      // CARGO-8266，铁路出口业务，自动装箱不要分摊
      if (job.lob === 'RE' || job.lob === 'RI') {
        if (i === 0) {
          usage.quantityContract = quantity
          usage.weightContract = weight
          usage.cubageContract = cubage
        }
      } else {
        if (i === len - 1) {
          usage.quantityContract = NumberUtils.roundHalfUp(quantity - tq, 0)
          usage.weightContract = NumberUtils.roundHalfUp(weight - tw, 3)
          usage.cubageContract = NumberUtils.roundHalfUp(cubage - tc, 3)
        } else {
          const size = EQSize.getEQSizeByCode(usage.container.eqSize)
          if (size) {
            const rate = parseInt(size.code) / tsize
            tq += usage.quantityContract = NumberUtils.roundHalfUp(rate * quantity, 0)
            tw += usage.weightContract = NumberUtils.roundHalfUp(rate * weight, 3)
            tc += usage.cubageContract = NumberUtils.roundHalfUp(rate * cubage, 3)
          } else {
            usage.quantityContract = usage.weightContract = usage.cubageContract = 0
          }
        }
      }
    }
  }

  //   /**
  //    * MSC自动装箱:并分配件毛体,件毛体只写到EdiContainer中
  //    */
  //   public static function autoLoadEdiContainer(job:Job):void
  //   {
  //     var quantity:int = job.quantityActual;
  //     var weight:Number = isNaN(job.weightActual) ? 0 : job.weightActual;
  //     var cubage:Number = isNaN(job.cubageActual) ? 0 : job.cubageActual;
  //
  //     // fix bug 1691 by marco.
  //     if (quantity == 0 && weight == 0 && cubage == 0)
  //     {
  //       quantity = job.quantityContract;
  //       weight = isNaN(job.weightContract) ? 0 : job.weightContract;
  //       cubage = isNaN(job.cubageContract) ? 0 : job.cubageContract;
  //     }
  //
  //     if (job.containerUsages == null)
  //       return;
  //
  //     var usage:ContainerUsage;
  //     var tsize:Number = 0;
  //     for each (usage in job.containerUsages)
  //     {
  //       var eqsize:EQSize = EQSize.getEQSizeByCode(usage.container.EQsize);
  //       if (eqsize)
  //         tsize += parseInt(eqsize.code);
  //     }
  //
  //     var tq:int = 0;
  //     var tw:Number = 0;
  //     var tc:Number = 0;
  //     var len:int = job.containerUsages.length;
  //     for (var i:int = 0; i < len; i++)
  //     {
  //       usage = job.containerUsages.getItemAt(i) as ContainerUsage;
  //       var usageEdiContainer:EDIContainer = usage.ediContainer;
  //       if (usageEdiContainer == null)
  //       {
  //         usageEdiContainer = new EDIContainer();
  //         usageEdiContainer.eqSize = usage.container.EQsize;
  //         usageEdiContainer.eqType = usage.container.EQtype;
  //         usageEdiContainer.containerUsage = usage;
  //       }
  //       if (i == len - 1)
  //       {
  //         usageEdiContainer.quantity = NumberUtils.roundHalfUp3(quantity - tq, 0);
  //         usageEdiContainer.weight = NumberUtils.roundHalfUp3(weight - tw, 3);
  //         usageEdiContainer.cubage = NumberUtils.roundHalfUp3(cubage - tc, 3);
  //       }
  //       else
  //       {
  //         var size:EQSize = EQSize.getEQSizeByCode(usage.container.EQsize);
  //         if (size)
  //         {
  //           var rate:Number = parseInt(size.code) / tsize;
  //           tq += usageEdiContainer.quantity = NumberUtils.roundHalfUp3(rate * quantity, 0);
  //           tw += usageEdiContainer.weight = NumberUtils.roundHalfUp3(rate * weight, 3);
  //           tc += usageEdiContainer.cubage = NumberUtils.roundHalfUp3(rate * cubage, 3);
  //         }
  //         else
  //         {
  //           usageEdiContainer.quantity = usageEdiContainer.weight = usageEdiContainer.cubage = 0;
  //         }
  //       }
  //       usage.quantity = usageEdiContainer.quantity;
  //       usage.weight = usageEdiContainer.weight;
  //       usage.cubage = usageEdiContainer.cubage;
  //     }
  //   }
  //
  /**
     * 验证件毛体是否相同(一个job装到一个箱子中时直接更新件毛体)
     */
  static validateContainerUsage(job) {
    let quantity = 0
    let weight = 0
    let cubage = 0
    if (job.containerUsages && job.containerUsages.length > 0) {
      for (const usage of job.containerUsages) {
        quantity += isNaN(usage.quantity) ? 0 : Number(usage.quantity)
        weight += isNaN(usage.weight) ? 0 : Number(usage.weight)
        cubage += isNaN(usage.cubage) ? 0 : Number(usage.cubage)
      }
      quantity = Number(quantity.toFixed())
      weight = Number(weight.toFixed(3))
      cubage = Number(cubage.toFixed(3))
    }
    return this.getCompareMessage(job, quantity, weight, cubage)
  }

  // 刷新装箱明细实际件毛体
  static refreshContainerUsageActualQwc(job) {
    const expression = parseInt(cache.config.get('ContainerUpdateJobQCW'))
    if (expression === 0) return
    if (!job) return
    if (this.checkDocBillType(job)) return
    if (job.containerUsages && job.containerUsages.length === 1) {
      const usage = job.containerUsages[0]
      if (expression === 2 || expression === 3) {
        if (job.quantityActual > 0) {
          usage.quantity = job.quantityActual
        }
        if (job.weightActual > 0) {
          usage.weight = job.weightActual
        }
        if (job.cubageActual > 0) {
          usage.cubage = job.cubageActual
        }
      }
    }
  }

  // 刷新装箱明细委托件毛体
  static refreshContainerUsageContractQwc(job, contractField) {
    const expression = parseInt(cache.config.get('ContainerUpdateJobQCW'))
    if (expression === 0) return
    if (!job) return
    if (contractField !== 'quantityContract' && contractField !== 'weightContract' && contractField !== 'cubageContract') return
    if (this.checkDocBillType(job)) return
    if (job.containerUsages && job.containerUsages.length === 1) {
      const usage = job.containerUsages[0]
      if (expression === 2 || expression === 3) {
        if (job[contractField] > 0) {
          usage[contractField] = job[contractField]
        }
      }
    }
  }

  /**
     * CARGO-1492
     * 已经拼箱的业务支持货物数量直接更改
     * 1.更改后自动更新装箱的数据
     * 2.如果有拆并单、一个委托在多个箱子中，则提示用户移出装箱后更改
     * 参数：ContainerUpdateJobQCW
     * 1、0:无同步;1:装箱->实际;2:实际->装箱;3:实际与装箱一致
     * 2、493需要配置为2
     * 3、475需要配置为1
     **/
  static async refContainerUsageQwc(job, viewPager = 0, btnSave = true) {
    const expression = parseInt(cache.config.get('ContainerUpdateJobQCW'))
    if (expression === 0) return
    if (!job) return
    if (this.checkDocBillType(job)) return
    if (job.containerUsages && job.containerUsages.length === 1) {
      const usage = job.containerUsages[0]
      switch (expression) {
        case 1:
        {
          if (viewPager !== 2) {
            await this.containerQwcSynJob(job, usage)
          }
          break
        }
        case 2:
        {
          if (viewPager !== 1) {
            this.containerJobSynQwc(job, usage)
          }
          break
        }
        case 3:
        {
          if (viewPager === 0 || viewPager === 2) {
            this.containerJobSynQwc(job, usage)
          } else {
            await this.containerQwcSynJob(job, usage)
          }
          break
        }
        default:
        {
          break
        }
      }
    } else if (btnSave && job.containerUsages && job.containerUsages.length > 1) { // CARGO-7908 装箱信息页，多个箱子的话能将所有箱子的件毛体之和同步过基本面的实际件毛体（单向同步：装箱->实际）
      const usageArray = job.containerUsages
      switch (expression) {
        case 1:
        {
          if (viewPager !== 2) {
            await this.containerQwcArraySynJob(job, usageArray)
          }
          break
        }
        case 3:
        {
          if (viewPager !== 0 && viewPager !== 2) {
            await this.containerQwcArraySynJob(job, usageArray)
          }
          break
        }
        default:
        {
          break
        }
      }
    }
  }

  /**
     * 装箱同步Job
     */
  static async containerQwcSynJob(job, usage) {
    if (usage.quantity > 0) {
      job.quantityActual = isNaN(usage.quantity) ? 0 : usage.quantity
    }
    if (usage.weight > 0) {
      job.weightActual = isNaN(usage.weight) ? 0 : usage.weight
    }
    if (usage.cubage > 0) {
      job.cubageActual = isNaN(usage.cubage) ? 0 : usage.cubage
    }
    if (job) {
      await CargoDocUtil.changeSynBillOfLadingQWC(job)
      // 同步委托件毛体
      const rule = parseInt(cache.config.get('SEQuantityWeightCubageRule'))
      if (rule === 2) {
        job.quantityContract = job.quantityActual
        job.weightContract = job.weightActual
        job.cubageContract = job.cubageActual
      }
      this.calculateChargeWeightSyn(job)
    }
  }

  /**
     * Job同步装箱
     */
  static containerJobSynQwc(job, usage, updateDirty = false) {
    if (job.quantityActual > 0) {
      usage.quantity = job.quantityActual
      if (updateDirty) {
        usage.isDirty = true
      }
    }
    if (job.weightActual > 0) {
      usage.weight = job.weightActual
      if (updateDirty) {
        usage.isDirty = true
      }
    }
    if (job.cubageActual > 0) {
      usage.cubage = job.cubageActual
      if (updateDirty) {
        usage.isDirty = true
      }
    }
    // 同时更新箱子上的件毛体
    if (Object.prototype.hasOwnProperty.call(usage, 'container') && usage.container) {
      usage.container.quantity = usage.quantity
      usage.container.weight = usage.weight
      usage.container.cubage = usage.cubage
    }
  }

  /**
     * CARGO-7908 多个装箱同步Job
     */
  static async containerQwcArraySynJob(job, usageArray) {
    var quantity = 0
    var weight = 0
    var cubage = 0

    for (const usage of usageArray) {
      if (!isNaN(usage.quantity)) { quantity += Number(usage.quantity) }
      if (!isNaN(usage.weight)) { weight += Number(usage.weight) }
      if (!isNaN(usage.cubage)) { cubage += Number(usage.cubage) }
    }

    if (quantity > 0) {
      job.quantityActual = NumberUtils.ToFixed2(quantity, 2)
    }
    if (weight > 0) {
      job.weightActual = NumberUtils.ToFixed2(weight, 3)
    }
    if (cubage > 0) {
      job.cubageActual = NumberUtils.ToFixed2(cubage, 3)
    }
    if (job != null) {
      await CargoDocUtil.changeSynBillOfLadingQWC(job)
      // 同步委托件毛体
      const rule = parseInt(cache.config.get('SEQuantityWeightCubageRule'))
      if (rule === 2) {
        job.quantityContract = job.quantityActual
        job.weightContract = job.weightActual
        job.cubageContract = job.cubageActual
      }
      this.calculateChargeWeightSyn(job)
    }
  }

  /**
     * 计费重量修改计算
     */
  static calculateChargeWeightSyn(job) {
    try {
      var ChargeWeightValueType = ChargeUtils.getChargeWeightValueType(true)
      var weight = ChargeWeightValueType === 1 ? job.weightContract : job.weightActual
      var cubage = ChargeWeightValueType === 1 ? job.cubageContract : job.cubageActual
      if (isNaN(weight) || isNaN(cubage)) return
      weight = weight / 1000
      if (cubage > weight) {
        weight = cubage
      }
      if (weight > 0 && weight < 1) {
        weight = 1.00
      }
      job.chargeWeight = parseFloat(Number(weight).toFixed(3))

      const defaultCubage = parseInt(cache.config.get('ExportChargeCubageMT'))
      if (job.cubageActual <= defaultCubage) {
        job.chargeCubage = defaultCubage
      } else {
        job.chargeCubage = job.cubageActual
      }
      // eslint-disable-next-line no-empty
    } catch (e) {

    }
  }

  /**
     * 是否做过拆并单
     */
  static checkDocBillType(job) {
    for (const doc of job.cargoDoc) {
      if (doc.docType === CargoDocConsts.HBL2) {
        if (job.typeHBL === BillType.MERGE_BILL_TYPE.code || job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
          return true
        }
      }
    }
    return false
  }

  static calcContainerUsageQWC(usage, job) {
    // 做过拆并单不进行同步，与原先保持一致
    if (this.checkDocBillType(job)) return
    const expression = parseInt(cache.config.get('ContainerUpdateJobQCW'))
    // 同步装箱件毛体
    if (expression === 2 || expression === 3) {
      let usagePoItems = job.poItems.filter(item => item.containerUsageKey === usage.uuid)
      if (job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
        usagePoItems = job.poItems
      }
      if (usagePoItems && usagePoItems.length > 0) {
        let quantity = 0
        let weight = 0
        let cubage = 0
        for (const poItem of usagePoItems) {
          quantity += poItem.quantity
          weight += poItem.grossWeight
          cubage += poItem.cubage
        }
        usage.quantity = String(quantity)
        usage.weight = NumberUtils.formatNumber(weight, 3, true)
        usage.cubage = NumberUtils.formatNumber(cubage, 3, true)
      } else {
        usage.quantity = 0
        usage.weight = 0
        usage.cubage = 0
      }
      // 箱子的件毛体由后端统一添加，前端小票在基本与装箱页签切换之后，保存时会传container，此container中的值不正确，所以后端统一刷件毛体
    }
  }

  //   /**
  //    * 主票装箱信息清空了
  //    */
  //   public static function refEmptyJobContainers(_job:Job):void
  //   {
  //     if(_job == null) return;
  //     if(!_job.isNewInstance() && _job.lclMaster != null)
  //     {
  //       var containers:ArrayCollection = _job.lclMaster.containers;
  //       if(containers == null || containers.length == 0)
  //       {
  //         _job.lclMaster.reloadContainers2(function(e:ResultEvent):void{},function(e:FaultEvent):void{});
  //       }
  //       else
  //       {
  //         for each(var container:Container in containers)
  //         {
  //           if(container.job == null)
  //           {
  //             container.job = _job.lclMaster;
  //           }
  //         }
  //       }
  //     }
  //   }
  //
  // ------------------------------------------------------------新改的装箱代码---------------------------------------------------------------

  /**
   *  h5 新加的方法，组装 containers.containerUsage  同 job.containerUsages 指向同一usage
   *  此方法 处理的仅针对db 已存在的数据 进行组装关联
   * @param job
   */
  static buildContainerUsages(job) {
    for (const container of job.containers) {
      if (StrUtils.isEmpty(container.uuid)) {
        continue
      }
      container.containerUsage = []
      if (job.containerUsages) {
        for (const usage of job.containerUsages) {
          if (usage.containerUuid === container.uuid) {
            container.containerUsage.push(usage)
            usage.container = container
          }
        }
      }
    }
  }
  /**
     * 根据SEQ 刷新装箱信息
     */
  static autoJustContainerUsages(job, action = '', canRemoved = true) {
    // 新增装箱信息
    if (job.seaEQ && job.seaEQ.length > 0) {
      for (let i = job.seaEQ.length - 1; i >= 0; i--) {
        const sea = job.seaEQ[i]
        const containerNumber = this.getJobContainerNumber(sea, job)
        if (containerNumber < sea.eqQuantity) {
          const quantity = sea.eqQuantity - containerNumber
          for (let j = 0; j < quantity; j++) {
            this.addJobContainerUsages(sea, job)
          }
        }
      }

      // 避免 copy,split动作 根据jobUuid 清空了数据
      if (canRemoved && action !== 'split' && action !== 'copy') {
        this.removeJobContainerUsages(job)
      }
    }
  }

  /**
   * 根据SEQ 刷新装箱信息
   * 与上面刷新autoJustContainerUsages不同，
   * 当箱号 封号已经填写 一样会有删除逻辑
   *
   */
  static autoJustContainerUsages2(job) {
    // 新增装箱信息
    if (job.seaEQ && job.seaEQ.length > 0) {
      const seaEqList = []
      this.setSeaEqList(job, seaEqList)
      for (let i = seaEqList.length - 1; i >= 0; i--) {
        const sea = seaEqList[i]
        const containerNumber = this.getJobContainerNumber2(sea, job)
        if (containerNumber < sea.eqQuantity) {
          const quantity = sea.eqQuantity - containerNumber
          for (let j = 0; j < quantity; j++) {
            this.addJobContainerUsages2(sea, job)
          }
        }
      }

      this.removeJobContainerUsages2(job)
    }
  }
  /**
   * 存在多个eqSize，eqType相同的情况
   * 先汇总在计算箱子
   * @param job
   * @param seaEqList
   */
  static setSeaEqList(job, seaEqList) {
    // 记录箱子原数量
    for (const data of job.seaEQ) {
      data.dataQuantity = data.eqQuantity
    }
    for (const data of job.seaEQ) {
      const key = data.eqType + data.eqSize + data.containerNo + data.sealNo + data.dataQuantity
      let isE = false
      for (const newData of seaEqList) {
        const newKey = newData.eqType + newData.eqSize + newData.containerNo + newData.sealNo + newData.dataQuantity
        if (key === newKey) {
          newData.eqQuantity += data.eqQuantity
          isE = true
        }
      }
      if (!isE) {
        seaEqList.push({ ...data })
      }
    }
  }
  static getJobContainerNumber2(sea, job) {
    let num = 0
    const containers = job.containers
    if (containers != null && containers.length > 0) {
      for (let i = containers.length - 1; i >= 0; i--) {
        const c = containers[i]
        if (this.check2(c, sea)) {
          num += 1
        }
      }
    }
    return num
  }

  static check2(c, s) {
    if (c.eqType === s.eqType && c.eqSize === s.eqSize && c.containerNo === s.containerNo &&
        c.sealNo === s.sealNo) {
      return true
    }
    return false
  }

  static addJobContainerUsages2(sea, job) {
    const container = new Container().fillDefaultValue().getData()
    const u = new ContainerUsage().fillDefaultValue().getData()
    const ediContainer = new EDIContainer().fillDefaultValue().getData()

    container.isDirty = true
    u.isDirty = true

    u.container = container

    u.jobUuid = job.uuid
    if (!job.containerUsages) {
      job.containerUsages = []
      job.containerUsages.push(u)
    } else {
      job.containerUsages.push(u)
    }

    container.jobUuid = job.uuid
    if (!job.containers) {
      job.containers = []
      job.containers.push(container)
    } else {
      job.containers.push(container)
    }

    // todo 此处会导致json 循环引用 与箱子关联的 装箱信息
    container.containerUsage = []
    container.containerUsage.push(u)

    // 与装箱信息关联的  ediContainer
    u.ediContainer = ediContainer

    container.sealNo = sea.sealNo
    container.containerNo = sea.containerNo
    container.eqSize = sea.eqSize
    container.eqType = sea.eqType
    container.containerWeight = 0
    container.inSpected = false
    u.quantity = 0
    u.weight = 0
    u.cubage = 0
    ediContainer.eqSize = sea.eqSize
    ediContainer.eqType = sea.eqType

    // 列显示 箱子相关信息 移至 usage
    u.eqSize = container.eqSize
    u.eqType = container.eqType
    u.containerNo = container.containerNo
    u.containerWeight = container.containerWeight
    u.sealNo = container.sealNo
    u.remark = container.remark
    if (job.lob === 'SE' || job.lob === 'SI') {
      u.soc = sea.soc
    }
  }

  /**
     * @private
     */
  static addJobContainerUsages(sea, job) {
    const container = new Container().fillDefaultValue().getData()
    const u = new ContainerUsage().fillDefaultValue().getData()
    const ediContainer = new EDIContainer().fillDefaultValue().getData()

    container.isDirty = true
    u.isDirty = true

    u.container = container

    u.jobUuid = job.uuid
    if (!job.containerUsages) {
      job.containerUsages = []
      job.containerUsages.push(u)
    } else {
      job.containerUsages.push(u)
    }

    container.jobUuid = job.uuid
    if (!job.containers) {
      job.containers = []
      job.containers.push(container)
    } else {
      job.containers.push(container)
    }

    // todo 此处会导致json 循环引用 与箱子关联的 装箱信息
    container.containerUsage = []
    container.containerUsage.push(u)

    // 与装箱信息关联的  ediContainer
    u.ediContainer = ediContainer

    if (job.lob === 'SI') {
      container.sealNo = sea.sealNo
      container.containerNo = sea.containerNo
    } else {
      container.sealNo = ''
      container.containerNo = ''
    }
    container.eqSize = sea.eqSize
    container.eqType = sea.eqType
    const eqType = getObjectByCache(TYPE_NAMES.basic_data_EQType, 'code', container.eqType)
    if (eqType) {
      if (eqType.reefer) {
        container.reefer = eqType.reefer
      }
      if (eqType.specialSize) {
        container.specialSize = eqType.specialSize
      }
    }
    container.containerWeight = 0
    container.inSpected = false
    u.quantity = 0
    u.weight = 0
    u.cubage = 0
    ediContainer.eqSize = sea.eqSize
    ediContainer.eqType = sea.eqType

    // 列显示 箱子相关信息 移至 usage
    u.eqSize = container.eqSize
    u.eqType = container.eqType
    u.containerNo = container.containerNo
    u.containerWeight = container.containerWeight
    u.sealNo = container.sealNo
    u.remark = container.remark

    if (job.lob === 'SE' || job.lob === 'SI') {
      u.soc = sea.soc
    }
  }

  /**
     * 删除不匹配的箱子信息
     */
  static removeJobContainerUsages(job) {
    if (job && job.containers) {
      const containerLen = job.containers.length
      // 先根据序号排个序在删除 ，优先新增未存数据，其次序号小的
      if (job.containers) {
        job.containers.sort((a, b) => {
          let num1 = 0
          let num2 = 0
          if (a.containerUsage && a.containerUsage.length > 0) {
            num1 = a.containerUsage[0].serialNo
          }
          if (b.containerUsage && b.containerUsage.length > 0) {
            num2 = b.containerUsage[0].serialNo
          }
          return num1 - num2
        })
      }
      for (let i = containerLen - 1; i >= 0; i--) {
        const c = job.containers[i]
        c.delete = false
        if (!this.isMatchSeqInfo(c, job) && StrUtils.isEmpty(c.containerNo) && StrUtils.isEmpty(c.sealNo)) {
          for (const cu1 of c.containerUsage) {
            cu1.containerUuid = ''
            cu1.jobUuid = ''
          }
          c.jobUuid = ''
          c.delete = true
        }
      }
      const containers = []
      for (const s of job.seaEQ) {
        const diffs = this.getDiffSeqEqContainer(s, job)
        var needDeleCount = diffs.length - s.eqQuantity
        if (needDeleCount > 0) {
          const allowDelete = this.getAllowDeleteContainer(diffs)
          if (allowDelete.length > 0) {
            for (let count = 0; count < needDeleCount; count++) {
              if (count < allowDelete.length) {
                const c2 = allowDelete[count] // Container
                if (!this.checkLclSlavesUsage(job, c2)) {
                  if (c2.containerUsage != null && c2.containerUsage.length > 0) {
                    for (let j = c2.containerUsage.length - 1; j >= 0; j--) {
                      const usage = c2.containerUsage[j]
                      usage.jobUuid = ''
                      usage.containerUuid = ''
                    }

                    containers.push(c2)
                  }
                }
              }
            }
          }
        }
      }
      if (containers.length > 0) {
        for (let k = containers.length - 1; k >= 0; k--) {
          const c3 = containers[k]
          c3.delete = false
          if (c3.containerUsage !== null && c3.containerUsage.length > 0) {
            for (let m = c3.containerUsage.length - 1; m >= 0; m--) {
              const usage2 = c3.containerUsage[m]
              usage2.jobUuid = ''
              usage2.containerUuid = ''
            }
          }
          c3.jobUuid = ''
          c3.delete = true
        }
      }
      // 根据  箱子上的 delete 标识 刷新job.containers
      const tempContainers = []
      for (const container of job.containers) {
        if (!container.delete) {
          tempContainers.push(container)
        }
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (container.delete && !StrUtils.isEmpty(container.uuid)) {
          if (!job.delContainerUuids) {
            job.delContainerUuids = []
          }
          job.delContainerUuids.push(container.uuid)
        }
      }

      job.containers.splice(0, job.containers.length, ...tempContainers)

      // 箱子 下的装箱 usage 集合到job 上
      const containerUsages = []
      for (const container of job.containers) {
        for (const usage of container.containerUsage) {
          containerUsages.push(usage)
        }
      }
      job.containerUsages.splice(0, job.containerUsages.length, ...containerUsages)
    }
  }
  /**
   * 删除不匹配的箱子信息
   */
  static removeJobContainerUsages2(job) {
    if (job && job.containers) {
      const containerLen = job.containers.length
      // 先根据序号排个序在删除 ，优先新增未存数据，其次序号小的
      if (job.containers) {
        job.containers.sort((a, b) => {
          let num1 = 0
          let num2 = 0
          if (a.containerUsage && a.containerUsage.length > 0) {
            num1 = a.containerUsage[0].serialNo
          }
          if (b.containerUsage && b.containerUsage.length > 0) {
            num2 = b.containerUsage[0].serialNo
          }
          return num1 - num2
        })
      }
      const seaEqList = []
      this.setSeaEqList(job, seaEqList)
      for (let i = containerLen - 1; i >= 0; i--) {
        const c = job.containers[i]
        c.delete = false
        if (!this.isMatchSeqInfo2(c, seaEqList)) {
          for (const cu1 of c.containerUsage) {
            cu1.containerUuid = ''
            cu1.jobUuid = ''
          }
          c.jobUuid = ''
          c.delete = true
        }
      }
      const containers = []
      for (const s of seaEqList) {
        const diffs = this.getDiffSeqEqContainer2(s, job, true)
        var needDeleCount = diffs.length - s.eqQuantity
        if (needDeleCount > 0) {
          const allowDelete = this.getAllowDeleteContainer(diffs, true)
          if (allowDelete.length > 0) {
            for (let count = 0; count < needDeleCount; count++) {
              if (count < allowDelete.length) {
                const c2 = allowDelete[count] // Container
                if (!this.checkLclSlavesUsage(job, c2)) {
                  if (c2.containerUsage != null && c2.containerUsage.length > 0) {
                    for (let j = c2.containerUsage.length - 1; j >= 0; j--) {
                      const usage = c2.containerUsage[j]
                      usage.jobUuid = ''
                      usage.containerUuid = ''
                    }

                    containers.push(c2)
                  }
                }
              }
            }
          }
        }
      }
      if (containers.length > 0) {
        for (let k = containers.length - 1; k >= 0; k--) {
          const c3 = containers[k]
          c3.delete = false
          if (c3.containerUsage !== null && c3.containerUsage.length > 0) {
            for (let m = c3.containerUsage.length - 1; m >= 0; m--) {
              const usage2 = c3.containerUsage[m]
              usage2.jobUuid = ''
              usage2.containerUuid = ''
            }
          }
          c3.jobUuid = ''
          c3.delete = true
        }
      }
      // 根据  箱子上的 delete 标识 刷新job.containers
      const tempContainers = []
      for (const container of job.containers) {
        if (!container.delete) {
          tempContainers.push(container)
        }
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (container.delete && !StrUtils.isEmpty(container.uuid)) {
          if (!job.delContainerUuids) {
            job.delContainerUuids = []
          }
          job.delContainerUuids.push(container.uuid)
        }
      }

      job.containers.splice(0, job.containers.length, ...tempContainers)

      // 箱子 下的装箱 usage 集合到job 上
      const containerUsages = []
      for (const container of job.containers) {
        for (const usage of container.containerUsage) {
          containerUsages.push(usage)
        }
      }
      job.containerUsages.splice(0, job.containerUsages.length, ...containerUsages)
    }
  }
  /**
   * 是否有匹配的装箱信息
   */
  static isMatchSeqInfo2(c, seaEqList) {
    for (const s of seaEqList) {
      if (this.check2(c, s)) {
        return true
      }
    }
    return false
  }
  /**
   * 获取有差别的装箱信息
   */
  static getDiffSeqEqContainer2(s, job, check = false) {
    const containers = []
    for (const c1 of job.containers) {
      if (this.check2(c1, s, check)) {
        containers.push(c1)
      }
    }
    return containers
  }
  /**
     * 获取有差别的装箱信息
     */
  static getDiffSeqEqContainer(s, job, check = false) {
    const containers = []
    for (const c1 of job.containers) {
      if (this.check(c1, s, check)) {
        containers.push(c1)
      }
    }
    return containers
  }

  /**
     * @private c2:Container
     */
  static checkLclSlavesUsage(job, c2) {
    if (job.masterFlag) {
      for (const usage of c2.containerUsage) {
        if (this.compareLclSlavesUsage(job, usage)) {
          return true
        }
      }
    }
    return false
  }

  /**
     * @private
     */
  static compareLclSlavesUsage(job, usage) {
    const lclSlaves = job.lclSlaves
    for (const lclJob of lclSlaves) {
      if (!StrUtils.isEmpty(usage.jobUuid) && usage.jobUuid === lclJob.uuid) {
        return true
      }
    }
    return false
  }

  /**
     * 获取可以删除的装箱信息
     */
  static getAllowDeleteContainer(containers, check = false) {
    const result = []
    for (const c of containers) {
      if (check || StrUtils.isEmpty(c.containerNo) && StrUtils.isEmpty(c.sealNo)) {
        result.push(c)
      }
    }
    return result
  }

  /**
     * 是否有匹配的装箱信息
     */
  static isMatchSeqInfo(c, job, check = false) {
    for (const s of job.seaEQ) {
      if (this.check(c, s, check)) {
        return true
      }
    }
    return false
  }

  /**
     * @private
     */
  static getJobContainerNumber(s, job, check = false) {
    // s:SeaEQ
    let num = 0
    const containers = job.containers
    if (containers != null && containers.length > 0) {
      for (let i = containers.length - 1; i >= 0; i--) {
        const c = containers[i]
        if (this.check(c, s, check)) {
          num += 1
        }
      }
    }
    return num
  }

  static check(c, s, check) {
    if (check) {
      if (c.eqType === s.eqType && c.eqSize === s.eqSize && c.containerNo === s.containerNo && c.sealNo === s.sealNo) {
        return true
      }
    } else {
      if (c.eqType === s.eqType && c.eqSize === s.eqSize) {
        return true
      }
    }
    return false
  }
  /**
     * 删除装箱信息验证
     */
  static checkInputContainerNo(s, job) {
    if (job.containers) {
      for (const c of job.containers) {
        if (c.eqType === s.eqType && c.eqSize === s.eqSize && (!StrUtils.isEmpty(c.containerNo) || !StrUtils.isEmpty(c.sealNo))) {
          return false
        }
      }
    }
    return true
  }

  /**
   * 获取箱量描述
   */
  static getContainerDesc(job) {
    if (!job) return ''
    const containerMap = {}
    let containerDesc = ''
    for (const cu of job.containerUsages) {
      const c = cu.container
      if (c) {
        if (!containerMap.hasOwnProperty(c.eqSize + c.eqType)) {
          containerMap[c.eqSize + c.eqType] = 1
        } else {
          containerMap[c.eqSize + c.eqType] += 1
        }
      }
    }
    for (const key in containerMap) {
      if (StrUtils.isEmpty(containerDesc)) {
        containerDesc = (containerMap[key] + ' * ' + key)
      } else {
        containerDesc += (',' + containerMap[key] + ' * ' + key)
      }
    }
    return StrUtils.isEmpty(containerDesc) ? i18n.t('CargoMsg.Cargo_None') : containerDesc
  }

  /**
   * 获取主票箱量描述
   */
  static getMasterJobContainerDesc(job) {
    if (!job) return ''
    const containerMap = {}
    let containerDesc = ''
    for (const c of job.containers) {
      if (!containerMap.hasOwnProperty(c.eqSize + c.eqType)) {
        containerMap[c.eqSize + c.eqType] = 1
      } else {
        containerMap[c.eqSize + c.eqType] += 1
      }
    }
    for (const key in containerMap) {
      if (StrUtils.isEmpty(containerDesc)) {
        containerDesc = (containerMap[key] + ' * ' + key)
      } else {
        containerDesc += (',' + containerMap[key] + ' * ' + key)
      }
    }
    return StrUtils.isEmpty(containerDesc) ? i18n.t('CargoMsg.Cargo_None') : containerDesc
  }

  /**
   *
   */
  static containerPushDataStyleFunction2(params, columnDataField) {
    let container = null
    const usage = params.data
    if (usage != null) {
      container = usage.container
    }
    if (!container) {
      container = params.data
    }
    const blueClass = { color: '#1F75D5' }
    const noneClass = { color: '' }
    if (container !== null && !StrUtils.isEmpty(container.jobUuid)) {
      if (columnDataField === 'eqSize') {
        return DataPushCompareUtils.comparePushData('箱型', params.value, container.uuid) ? blueClass : noneClass
      } else if (columnDataField === 'eqType') {
        return DataPushCompareUtils.comparePushData('箱种', params.value, container.uuid) ? blueClass : noneClass
      } else if (columnDataField === 'sealNo') {
        return DataPushCompareUtils.comparePushData('封号', params.value, container.uuid) ? blueClass : noneClass
      } else if (columnDataField === 'containerWeight') {
        return DataPushCompareUtils.comparePushData('箱重', String(params.value), container.uuid) ? blueClass : noneClass
      } else if (columnDataField === 'quantity') {
        return DataPushCompareUtils.comparePushData('件数', String(params.value), container.uuid) ? blueClass : noneClass
      } else if (columnDataField === 'weight') {
        return DataPushCompareUtils.comparePushData('重量', String(params.value), container.uuid) ? blueClass : noneClass
      } else if (columnDataField === 'cubage') {
        return DataPushCompareUtils.comparePushData('体积', String(params.value), container.uuid) ? blueClass : noneClass
      }
    }
    return noneClass
  }
  static containerPushDataStyleFunction(data, columnDataField) {
    let container = null
    const usage = data
    if (usage != null) {
      container = usage.container
    }
    if (!container) {
      container = data
    }
    if (container !== null && !StrUtils.isEmpty(container.jobUuid)) {
      const blueClass = 'blue'
      if (columnDataField === 'eqSize') {
        return DataPushCompareUtils.comparePushData('箱型', container.eqSize, container.uuid) ? blueClass : ''
      } else if (columnDataField === 'eqType') {
        return DataPushCompareUtils.comparePushData('箱种', container.eqType, container.uuid) ? blueClass : ''
      } else if (columnDataField === 'sealNo') {
        return DataPushCompareUtils.comparePushData('封号', container.sealNo, container.uuid) ? blueClass : ''
      } else if (columnDataField === 'containerWeight') {
        return DataPushCompareUtils.comparePushData('箱重', String(container.containerWeight), container.uuid) ? blueClass : ''
      } else if (columnDataField === 'quantity') {
        return DataPushCompareUtils.comparePushData('件数', String(container.quantity), container.uuid) ? blueClass : ''
      } else if (columnDataField === 'weight') {
        return DataPushCompareUtils.comparePushData('重量', String(container.weight), container.uuid) ? blueClass : ''
      } else if (columnDataField === 'cubage') {
        return DataPushCompareUtils.comparePushData('体积', String(container.cubage), container.uuid) ? blueClass : ''
      }
    }
    return ''
  }
  //
  /**
   * 检查是否可以删除，录入装箱信息和装过小票的不能删除
   */
  static checkCanDelSeaEQ(seaEQ, job) {
    for (const c of job.containers) {
      if (job.containerLoadType === 'BCF' && seaEQ.eqSize === c.eqSize && seaEQ.eqType === c.eqType &&
          (!StrUtils.isEmpty(c.containerNo) || !StrUtils.isEmpty(c.sealNo))) {
        return false
      }
      if (job.containerLoadType !== 'BCF' && seaEQ.eqSize === c.eqSize && seaEQ.eqType === c.eqType &&
        (!StrUtils.isEmpty(c.containerNo) || !StrUtils.isEmpty(c.sealNo) || (c.containerUsage != null && c.containerUsage.length > 0))) {
        return false
      }
    }
    return true
  }

  /**
   * 检查是否可以删除，海运进口主单已输入箱型箱种信息不能删
   */
  static checkCanDelSeaEQBySeqEQ(seaEQ) {
    if (!StrUtils.isEmpty(seaEQ.containerNo) || !StrUtils.isEmpty(seaEQ.sealNo)) {
      return false
    }

    return true
  }
  /**
   *  组合container和seaEq关系
   */
  static refreshContainerSeaEQ(job) {
    for (const c of job.containers) {
      for (const s of job.seaEQ) {
        if (c.eqType === s.eqType && c.eqSize === s.eqSize) {
          s.joinContainerId = uidUtil.createUID()
          c.seaEqs = s
          break
        }
      }
    }
  }

  //   public static function eqSizeSortCompare(obj1:Object, obj2:Object ):int
  //   {
  //     if ( !obj1 && !obj2 )
  //       return 0;
  //
  //     if ( !obj1)
  //       return 1;
  //
  //     if ( !obj2)
  //       return -1;
  //     var containerOne:Container = null;
  //     var containerTwo:Container = null;
  //     var usageOne:ContainerUsage = obj1 as ContainerUsage;
  //     var usageTwo:ContainerUsage = obj2 as ContainerUsage;
  //     if(usageOne != null) {
  //       containerOne = usageOne.container;
  //     }
  //     if(null == containerOne)
  //     {
  //       containerOne = obj1 as Container;
  //     }
  //
  //     if(usageTwo != null) {
  //       containerTwo = usageTwo.container;
  //     }
  //     if(null == containerTwo)
  //     {
  //       containerTwo = obj2 as Container;
  //     }
  //
  //     if(containerOne && containerTwo)
  //     {
  //       if (containerOne.EQtype == null && containerTwo.EQtype == null)
  //         return 0;
  //
  //       if (containerOne.EQtype == null)
  //         return 1;
  //
  //       if (containerTwo.EQtype == null)
  //         return -1;
  //       if(containerOne.EQtype != null && containerTwo.EQtype != null)
  //       {
  //         if (containerOne.EQsize < containerTwo.EQsize)
  //           return -1;
  //
  //         if (containerOne.EQsize > containerTwo.EQsize)
  //           return 1;
  //         if (containerOne.EQsize == containerTwo.EQsize)
  //         {
  //           if ( containerOne.EQtype < containerTwo.EQtype )
  //             return -1;
  //
  //           if ( containerOne.EQtype > containerTwo.EQtype )
  //             return 1;
  //         }
  //       }
  //     }
  //     return 0;
  //   }
  //
  //   public static function eqTypeSortCompare(obj1:Object, obj2:Object ):int
  //   {
  //     if ( !obj1 && !obj2 )
  //       return 0;
  //
  //     if ( !obj1)
  //       return 1;
  //
  //     if ( !obj2)
  //       return -1;
  //     var containerOne:Container = null;
  //     var containerTwo:Container = null;
  //     var usageOne:ContainerUsage = obj1 as ContainerUsage;
  //     var usageTwo:ContainerUsage = obj2 as ContainerUsage;
  //     if(usageOne != null) {
  //       containerOne = usageOne.container;
  //     }
  //     if(null == containerOne)
  //     {
  //       containerOne = obj1 as Container;
  //     }
  //
  //     if(usageTwo != null) {
  //       containerTwo = usageTwo.container;
  //     }
  //     if(null == containerTwo)
  //     {
  //       containerTwo = obj2 as Container;
  //     }
  //
  //     if(containerOne && containerTwo)
  //     {
  //       if (containerOne.EQtype == null && containerTwo.EQtype == null)
  //         return 0;
  //
  //       if (containerOne.EQtype == null)
  //         return 1;
  //
  //       if (containerTwo.EQtype == null)
  //         return -1;
  //       if(containerOne.EQtype != null && containerTwo.EQtype != null)
  //       {
  //         if (containerOne.EQtype < containerTwo.EQtype)
  //           return -1;
  //
  //         if (containerOne.EQtype > containerTwo.EQtype)
  //           return 1;
  //         if (containerOne.EQtype == containerTwo.EQtype)
  //         {
  //           if ( containerOne.EQsize < containerTwo.EQsize )
  //             return -1;
  //
  //           if ( containerOne.EQsize > containerTwo.EQsize )
  //             return 1;
  //         }
  //       }
  //     }
  //     return 0;
  //   }
  // }

  // 当箱货信息清空时，对应的装箱和装箱明细也要清空
  static clearContainer(job) {
    if (!job.seaEQ || job.seaEQ.length === 0) {
      if (job.containers) {
        if (!job.delContainerUuids) {
          job.delContainerUuids = []
        }
        for (const container of job.containers) {
          if (!container.uuid) continue
          job.delContainerUuids.push(container.uuid)
        }
        job.containers = []
      }
      if (job.containerUsages) {
        if (!job.delContainerUsageUuids) {
          job.delContainerUsageUuids = []
        }
        for (const containerUsage of job.containerUsages) {
          if (!containerUsage.uuid) continue
          job.delContainerUsageUuids.push(containerUsage.uuid)
        }
        job.containerUsages = []
      }
    }
  }

  /**
   * 更新箱型箱种
   * @param job
   * @param oldEqType
   * @param oldEqSize
   * @param newEqType
   * @param newEqSize
   */
  static updateEqTypeOrEqSize(job, oldEqType, oldEqSize, newEqType, newEqSize) {
    if (!job || !job.seaEQ || job.seaEQ.length === 0) return
    if (job.lob === 'SE' || job.lob === 'SI') {
      if (job.containers && job.containers.length > 0) {
        for (const container of job.containers) {
          if (container.eqType === oldEqType && container.eqSize === oldEqSize) {
            container.eqType = newEqType
            container.eqSize = newEqSize
            container.isDirty = true
          }
        }
      }
      if (job.containerUsages && job.containerUsages.length > 0) {
        for (const usage of job.containerUsages) {
          if (usage.eqType === oldEqType && usage.eqSize === oldEqSize) {
            usage.eqType = newEqType
            usage.eqSize = newEqSize
            usage.isDirty = true
          }
        }
      }
    }
  }

  /**
   * 根据SEQ 刷新装箱信息
   * 仅用于新增或复制业务
   *
   */
  static autoRefreshContainerUsages(job) {
    let serialNo = 1
    // job.containers = []
    // job.containerUsages = []
    if (job.seaEQ && job.seaEQ.length > 0) {
      for (let i = job.seaEQ.length - 1; i >= 0; i--) {
        const sea = job.seaEQ[i]
        for (let j = sea.eqQuantity - 1; j >= 0; j--) {
          this.createContainer(job, sea, serialNo)
          serialNo++
        }
      }
    }
  }
  static createContainer(job, sea, serialNo) {
    const container = new Container().fillDefaultValue().getData()
    container.eqSize = sea.eqSize
    container.eqType = sea.eqType
    container.jobUuid = job.uuid
    container.uuid = 'addContainer_' + getUuid()
    container.isDirty = true
    const u = new ContainerUsage().fillDefaultValue().getData()
    u.isDirty = true
    u.container = container
    u.eqSize = sea.eqSize
    u.eqType = sea.eqType
    u.jobUuid = job.uuid
    u.serialNo = serialNo
    u.containerUuid = container.uuid
    u.uuid = 'addContainerUsage_' + getUuid()
    container.containerUsage.push(u)
    if (!job.containers) {
      job.containers = []
    }
    job.containers.push(container)
    if (!job.containerUsages) {
      job.containerUsages = []
      job.containerUsages.push(u)
    } else {
      job.containerUsages.push(u)
    }
    // 集卡拖车中 一个箱子一个客户门点
    if (job.containerLoadType === ContainerLoadType.STUFFY_TT.code) {
      let copyTrucking = null
      // 复制的场景下
      const length = job.copyTruckingData.length
      if (job.copyIntegratedJob && job.copyTruckingData && length > 0) {
        for (let i = length - 1; i >= 0; i--) {
          const t = job.copyTruckingData[i]
          const uuids = t.uuid.split(',,')
          if (uuids[0] === u.eqSize + u.eqType) {
            // 根据箱型箱种匹配的一个客户门点，箱子上赋值堆场
            u.truckingPlaceOfDep = t.truckingPlaceOfDep
            u.truckingPlaceOfDest = t.truckingPlaceOfDest
            copyTrucking = { ...t }
            job.copyTruckingData.splice(i, 1)
            break
          }
        }
      }
      this.createTrucking(u, job, copyTrucking)
    }
  }
  static createTrucking(cu, job, copyTrucking = null) {
    if (!job.trucking) {
      job.trucking = []
    }
    job.trucking.push(this.doCreateTrucking(cu, job, copyTrucking))
  }
  static doCreateTrucking(cu, job, copyTrucking = null) {
    const trucking = new Trucking().fillDefaultValue().getData()
    trucking.loadingPortService = true
    if (job.trucking.length === 0) {
      trucking.quantity = job.quantityActual
      trucking.weight = job.weightActual
      trucking.cubage = job.cubageActual
    }
    trucking.jobUuid = job.uuid
    // 新增的时候门点相关先默认空
    trucking.driver = ''
    trucking.driverTel = ''
    trucking.carryingCmp = ''
    trucking.doorName = ''
    trucking.doorMan = ''
    trucking.doorManTel = ''
    trucking.doorAddr = ''
    trucking.remark = ''
    trucking.sameTransportationCompany = true
    trucking.sameDoorPoint = true
    // 复制了客户门点
    if (copyTrucking) {
      trucking.sameTransportationCompany = copyTrucking.sameTransportationCompany // 运输公司相同
      trucking.sameDoorPoint = copyTrucking.sameTransportationCompany // 门点相同

      trucking.remarks = copyTrucking.remarks
      trucking.doorName = copyTrucking.doorName
      trucking.doorMan = copyTrucking.doorMan
      trucking.doorAddr = copyTrucking.doorAddr
      trucking.doorManTel = copyTrucking.doorManTel
      trucking.cityCode = copyTrucking.cityCode
      trucking.palletSum = copyTrucking.palletSum
    } else if (job.trucking && job.trucking.length > 0) {
      // 有其他门点 先同步一下
      const d = job.trucking.find(p => p.sameTransportationCompany === true)
      if (d) {
        trucking.driver = d.driver
        trucking.driverTel = d.driverTel
        trucking.carryingCmp = d.carryingCmp
      }
      const s = job.trucking.find(p => p.sameDoorPoint === true)
      if (s) {
        trucking.doorName = s.doorName
        trucking.doorMan = s.doorMan
        trucking.doorManTel = s.doorManTel
        trucking.doorAddr = s.doorAddr
        trucking.remark = s.remark
      }
    }
    trucking.uuid = 'addTrucking_' + cu.uuid // 新增的场景先记录箱子的唯一标识，后端处理关联逻辑
    cu.truckingInfoUuid = trucking.uuid
    trucking.truckOrderNo = JobUtils.createTruckOrderNo(job)
    return trucking
  }

  /**
   * 根据VGM计费方式，刷新VGM重量
   * @param container
   */
  static refreshVgmWeight(container = null) {
    if (!container) return
    if (container.vGMWeightingMeothd === 'SM2') {
      const weight = Number(container['weight'] || 0)
      const containerWeight = Number(container['containerWeight'] || 0)
      container.vGMWeight = weight + containerWeight
    } else if (container.vGMWeightingMeothd === 'SM1') {
      container['vGMWeight'] = 0
    }
  }
}
